/**
 * GTN Header — frontend view script.
 * Handles mobile navigation toggle.
 */
( function () {
	const toggle    = document.getElementById( 'gtn-nav-toggle' );
	const mobileNav = document.getElementById( 'gtn-mobile-nav' );
	const closeEls  = mobileNav ? mobileNav.querySelectorAll( '[data-gtn-mobile-close]' ) : [];
	const panel     = mobileNav ? mobileNav.querySelector( '.gtn-mobile-nav__panel' ) : null;
	let isAnimating = false;

	if ( toggle && mobileNav ) {
		function lockBodyScroll( lock ) {
			document.body.classList.toggle( 'gtn-mobile-nav-open', lock );
		}

		function openMenu() {
			if ( isAnimating || ! panel ) {
				return;
			}

			isAnimating = true;
			mobileNav.removeAttribute( 'hidden' );
			// Force reflow so transition always runs on open.
			// eslint-disable-next-line no-unused-expressions
			panel.offsetHeight;
			mobileNav.classList.add( 'is-open' );
			mobileNav.setAttribute( 'aria-hidden', 'false' );
			toggle.setAttribute( 'aria-expanded', 'true' );
			toggle.classList.add( 'is-active' );
			lockBodyScroll( true );

			window.setTimeout( function () {
				isAnimating = false;
			}, 320 );
		}

		function closeMenu( returnFocus = false ) {
			if ( isAnimating || ! panel || mobileNav.hasAttribute( 'hidden' ) ) {
				return;
			}

			isAnimating = true;
			mobileNav.classList.remove( 'is-open' );
			mobileNav.setAttribute( 'aria-hidden', 'true' );
			toggle.setAttribute( 'aria-expanded', 'false' );
			toggle.classList.remove( 'is-active' );
			lockBodyScroll( false );

			window.setTimeout( function () {
				mobileNav.setAttribute( 'hidden', '' );
				isAnimating = false;
				if ( returnFocus ) {
					toggle.focus();
				}
			}, 320 );
		}

		toggle.addEventListener( 'click', function () {
			const isOpen = mobileNav.hasAttribute( 'hidden' );

			if ( isOpen ) {
				openMenu();
			} else {
				closeMenu();
			}
		} );

		closeEls.forEach( function ( el ) {
			el.addEventListener( 'click', function () {
				closeMenu( true );
			} );
		} );

		mobileNav.addEventListener( 'click', function ( e ) {
			const link = e.target.closest( 'a' );
			if ( link && link.getAttribute( 'href' ) ) {
				closeMenu();
			}
		} );

		// Close on ESC key.
		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Escape' && ! mobileNav.hasAttribute( 'hidden' ) ) {
				closeMenu( true );
			}
		} );
	}

} )();
